export const isUserInUnsupportedState = (
  state?: string | null,
  jurisdiction?: string[],
) => state && jurisdiction && !jurisdiction.includes(state);
